import { Box } from "@chakra-ui/react";

export default function Logo(props) {
  return (
    <Box {...props}>
      <img src="https://res.cloudinary.com/qonvex-tech/image/upload/v1639927190/Qonvey%20LandingPage/Logo_io7jew.png" alt="qonvey logo" />
    </Box>
  );
}